document.addEventListener('DOMContentLoaded',function() {

    const logo = document.querySelector('.o-logo__img');

    const init = ()=> {
        logo.addEventListener('mouseover', ()=> {
            logo.classList.add('animated');
        })

        logo.addEventListener("animationend", (e) => {
            logo.classList.remove('animated');
        });
    }

    // logo animation disabled at Barni request
    // logo ? init() : false;

}, false);
